import React from 'react';

export default function linkPlugin() {
  return {
    commands: {
      wrapLink(editor, href) {
        editor.wrapInline({
          type: 'link',
          data: { href },
        });

        editor.moveToEnd();
      },

      unwrapLink(editor) {
        editor.unwrapInline('link');
      },
    },

    queries: {
      hasLinks(editor) {
        const { value } = editor;
        return value.inlines.some((inline) => inline.type === 'link');
      },
    },

    renderInline(props, editor, next) {
      const { attributes, children, node } = props;

      switch (node.type) {
        case 'link': {
          const { data } = node;
          const href = data.get('href');
          return (
            <a {...attributes} href={href} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          );
        }

        default: {
          return next();
        }
      }
    },

  };
}

export function onClickLink(event, editor) {
  event.preventDefault();
  const { value } = editor;

  if (editor.hasLinks()) {
    editor.unwrapLink();
  } else if (value.selection.isExpanded) {
    const href = window.prompt('Enter the URL of the link:'); // eslint-disable-line
    if (href == null) {
      return;
    }

    editor.wrapLink(href);
  } else {
    const href = window.prompt('Enter the URL of the link:'); // eslint-disable-line
    if (href == null) {
      return;
    }

    const text = window.prompt('Enter the text for the link:'); // eslint-disable-line
    if (text == null) {
      return;
    }

    editor
      .insertText(text)
      .moveFocusBackward(text.length)
      .wrapLink(href);
  }
}
